// The supported-language vocabulary read, carved verbatim from
// `src/api/scribeAPI.ts` (which now consumes this module) with the
// session-header modal cores. Transport comes from the `@heidi/api`
// configured-client registry; the request path is byte-identical.
//
// DOMAIN: the endpoint is global rather than session-scoped and carried
// `@domain REVIEW` — the hub's marker for "unclassified", not for "owned
// elsewhere". It resolves to session here because the two `ui--session-header`
// exception cones blocked on it name this door by name ("carve
// `useQuerySupportedLanguages` behind `@heidi/session/data`"). If a later
// reader decides the vocabulary is platform rather than session, it moves
// again as a whole file; nothing about the carve depends on the tag.

import { getScribeHttpClients } from '@heidi/api/client';

import { type SupportedLanguagesResponse } from '../../contracts';

export const getSupportedLanguages = () => {
  return getScribeHttpClients().scribeHttp.get<SupportedLanguagesResponse>(
    `/language/supported-languages`
  );
};
